import { FC } from 'react';
import styled from 'styled-components';
import { theme } from '@salecycle/ui-component-library';

export interface IProps extends IntrinsicProps {
  /** Text color. Defaults to theme.designToken.Neutral900 */
  color?: string;
  fontSize: string;
  fontWeigth: string;
  lineHeight: string;
  letterSpacing: string;
  textDecoration: string;
  textStyle?: string;
  /** Variation of text */
  Type: Type;
}

const TextItem = styled.div<IProps>`
  color: ${props => (props.color ? props.color : theme.designToken.neutral900)};
  font-size: ${props => props.fontSize};
  line-height: ${props => props.lineHeight}px;
  font-weight: ${props => props.fontWeigth};
  letter-spacing: ${props => props.letterSpacing};
  text-decoration: ${props => props.textDecoration};
  font-style: ${props => (props.textStyle ? props.textStyle : 'normal')};
`;

const Link = styled.a<IProps>`
  color: ${props => (props.color ? props.color : theme.designToken.primary500)};
  font-size: ${props => props.fontSize}px;
  line-height: ${props => props.lineHeight}px;
  font-weight: ${props => props.fontWeigth};
  letter-spacing: ${props => props.letterSpacing};
  text-decoration: ${props => props.textDecoration};
  font-style: ${props => (props.textStyle ? props.textStyle : 'normal')};
`;

type Type = 'Text' | 'Link';

export const Text: FC<IProps> = ({
  color,
  Type,
  fontSize,
  lineHeight,
  fontWeigth,
  letterSpacing,
  textDecoration,
  textStyle,
  children,
  ...props
}) => {
  if (Type === 'Text') {
    return (
      <TextItem
        color={color}
        fontSize={fontSize}
        Type={Type}
        lineHeight={lineHeight}
        fontWeigth={fontWeigth}
        letterSpacing={letterSpacing}
        textDecoration={textDecoration}
        textStyle={textStyle}
        {...props}
      >
        {children}
      </TextItem>
    );
  } else if (Type === 'Link') {
    return (
      <Link
        color={color}
        fontSize={fontSize}
        Type={Type}
        lineHeight={lineHeight}
        fontWeigth={fontWeigth}
        letterSpacing={letterSpacing}
        textDecoration={textDecoration}
        textStyle={textStyle}
        {...props}
      >
        {children}
      </Link>
    );
  }
};
